export default __webpack_public_path__ + "resources/docs/2_recommendations_for_success_RU_compressed.9e1acc34.pdf";